<template>
  <div class="coupons">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>
          订单优惠券
        </h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入优惠券名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增优惠券</el-button>
        <el-button type="primary" @click="onShareClick" class="c-m-l-10">分享私密优惠券</el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'regex:title|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'coupon',
                title: '订单优惠券'
              },
              { dynamic: true, preset }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          @selection-change="onSelectionChange"
          border
          @header-dragend="osg.colWidthChange"
          row-key="_id"
        >
          <el-table-column
            type="selection"
            width="55"
            fixed
            :selectable="selectable"
            :reserve-selection="true"
          ></el-table-column>
          <c-table :fields="extFields">
            <template slot="stockNum">
              <el-table-column
                label="代金券批次号"
                :formatter="formatStockNum"
                width="180px"
                show-overflow-tooltip
              ></el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="
                      doRecord(scope.row._id);
                      openRecordDetail = true;
                    "
                  >
                    查看领取记录
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doStock(scope.row._id)">
                    修改最大发券数
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="scope.row.state == 1 && osg.has(`Coupons,distribute`)"
                    @click.native="doDistribute(scope.row)"
                  >
                    发放优惠券
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="优惠券 " :visible.sync="openDetail" width="800px">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :options="options"
        @changeForm="osg.changeForm"
        ref="form"
        labelWidth="140px"
      >
        <template slot="ladderParts">
          <el-table :data="formData.ladderParts" border style="width: 100%" class="c-table-border">
            <el-table-column label="批次号(选填)" header-align="center">
              <template slot-scope="scope">
                <el-input
                  placeholder="批次号(选填)"
                  v-model="scope.row.ladderStockNum"
                  class="stockNum-view"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="门槛（元）" header-align="center">
              <template slot-scope="scope">
                <el-input-number
                  placeholder="满多少"
                  v-model="scope.row.ladderPrerequisite"
                  :controls="false"
                  :precision="0"
                  class="stockNum-view"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="面额（元）" header-align="center">
              <template slot-scope="scope">
                <el-input-number
                  placeholder="减多少"
                  v-model="scope.row.ladderAmount"
                  :controls="false"
                  class="stockNum-view"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="商品标记(选填)" header-align="center">
              <template slot-scope="scope">
                <el-input
                  placeholder="商品标记(选填)"
                  v-model="scope.row.ladderGoodsTag"
                  class="stockNum-view"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" width="50px">
              <template slot-scope="scope">
                <el-button type="text" class="c_red" @click="removeStock(scope.$index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button class="c-m-t-10" @click="addStock">添加批次号</el-button>
        </template>

        <template slot="scopeOrgIds">
          <el-cascader
            v-model="formData.scopeOrgIds"
            :options="supplierList"
            :props="{
              multiple: true,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            collapse-tags
            @change="$forceUpdate()"
          ></el-cascader>
        </template>

        <template slot="expenseType">
          <div class="c-flex">
            <div style="display: flex; align-items: center;">
              <el-radio
                :label="0"
                v-model="formData.expenseType"
                @change="
                  delete formData.expense;
                  $forceUpdate();
                "
              >
                按比例
              </el-radio>
              <template v-if="formData.expenseType == 0">
                <el-input-number
                  v-model="formData.expense"
                  :controls="false"
                  :min="0"
                  :precision="0"
                  placeholder="请输入比例"
                  style="border-radius: 3px 0 0 3px"
                ></el-input-number>
                %
              </template>
            </div>
            <div style="margin-left:30px;display: flex; align-items: center;">
              <el-radio
                :label="1"
                v-model="formData.expenseType"
                @change="
                  delete formData.expense;
                  $forceUpdate();
                "
              >
                按定额
              </el-radio>
              <template v-if="formData.expenseType == 1">
                <el-input-number
                  v-model="formData.expense"
                  :controls="false"
                  :min="0"
                  :precision="0"
                  placeholder="请输入金额"
                ></el-input-number>
              </template>
            </div>
          </div>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="优惠券领取记录" :visible.sync="openRecordDetail" width="1000px">
      <div style="height: 100%; display: flex; flex-direction: column">
        <div style="height: 100%; display: flex; flex-direction: column">
          <div style="min-height: 400px; flex: 1">
            <div style="margin: 10px 0">
              <el-input
                placeholder="请输入优惠券名称/券号/手机号"
                style="width: 300px"
                v-model="searchRecordValue"
                clearable
                @clear="
                  recordFpi.page = 1;
                  doRecord(couponId);
                "
                @keyup.enter.native="
                  recordFpi.page = 1;
                  doRecord(couponId);
                "
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    fpi.page = 1;
                    doRecord(couponId);
                  "
                ></el-button>
              </el-input>
            </div>
            <el-table
              ref="recordTable"
              height="calc(100% - 80px)"
              :data="recordFpi.data"
              v-if="recordFpi.data && recordFpi.data.length && extFieldsCouponPrinting.length"
            >
              <c-table :fields="extFieldsCouponPrinting">
                <template slot="value">
                  <el-table-column label="面额（元）" width="120px">
                    <template
                      slot-scope="scope"
                      v-if="scope.row.type == '1' || scope.row.type == '3'"
                    >
                      {{ scope.row.value }}
                    </template>
                  </el-table-column>
                </template>
                <template slot="discount">
                  <el-table-column label="折扣" width="120px">
                    <template slot-scope="scope" v-if="scope.row.type == '2'">
                      {{ scope.row.value }}
                    </template>
                  </el-table-column>
                </template>
              </c-table>
            </el-table>
          </div>
        </div>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="recordFpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="recordFpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="recordFpi.total"
        ></el-pagination>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          @click="
            openRecordDetail = false;
            couponId = '';
          "
        >
          关 闭
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="发放优惠券" :visible.sync="distributeData.openDetail">
      <el-form
        :model="distributeData.formData"
        ref="distributeDataForm"
        label-width="160px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item
          label="选择客户"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '选择客户不能为空'
          }"
          prop="contactId"
        >
          <el-select
            v-model="distributeData.formData.contactId"
            :remote-method="querySearch"
            filterable
            remote
            placeholder="可搜索人员姓名/手机"
            size="small"
            style="width:100%"
            @change="distributeContactChange"
          >
            <el-option
              v-for="(item, i) in options.contacts"
              :key="i"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="distributeData.openDetail = false">
          关 闭
        </el-button>
        <el-button type="primary" @click="doSaveDistributeData">
          确定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="分享私密优惠券"
      :visible.sync="privateCoupon.openDetail"
      custom-class="privateCoupon-dialog"
      :destroy-on-close="true"
    >
      <div style="display:inline-block;text-align: left;">
        <div>已选中以下私密优惠券：</div>
        <div v-for="(item, i) in selectedRows" :key="i">{{ i + 1 }}.{{ item.title }}</div>
      </div>
      <div
        class="qrcode c-flex c-flex-center"
        :id="'qrcode_' + privateCoupon.qrCodeKey"
        style="margin-top:20px"
        ref="qrCodeUrl"
      ></div>
      <div slot="footer">
        <el-button @click="privateCoupon.openDetail = false">
          关 闭
        </el-button>
        <el-button type="primary" @click="downloadCode">
          下载二维码
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
  activated() {
    window.$this = this;
  },
  name: 'coupons',
  data() {
    window.$this = this;
    return {
      name: 'coupon',
      refresh: true,
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        timeRange: [], // 领取时间范围
        durationTimeRange: [], // 使用时间范围
        ladderParts: []
      },
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      options: {},
      isEdit: false, //编辑为true,新增为false
      openRecordDetail: false, //优惠券领取记录弹出
      extFieldsCouponPrinting: [], //优惠券扩展字段
      //优惠券领取记录
      recordFpi: {
        data: []
      },
      couponId: '', //用于查询优惠券记录的优惠券id
      searchRecordValue: '', //优惠券过滤条件
      distributeData: { formData: {}, openDetail: false }, //发放优惠券对象
      selectedRows: [],
      privateCoupon: {
        openDetail: false,
        qrCodeKey: new Date() // 处理二维码下载缓存的问题
      },
      supplierList: []
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('coupon', () => {
      this.osg.getFpi();
      this.getData();
      //优惠券领取
      this.osg.getFields('couponPrinting', () => {}, this, 'extFieldsCouponPrinting');
      //获取组织信息
      this.getOrgs();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      if (this.openRecordDetail) {
        this.recordFpi.rows = pageSize;
        this.doRecord(this.couponId);
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.openRecordDetail) {
        this.recordFpi.page = currentPage;
        this.doRecord(this.couponId);
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {}, ladderParts: [] };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:title|string#or': this.searchValue,
        'regex:_id|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.setFpi(params);
      this.osg.ajax('/basic/coupon/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    //获取一些组织数据
    getOrgs() {
      this.osg.ajax(
        'org/query.do',
        {
          notFilterOrgId: '1',
          sortField: 'order'
        },
        res => {
          console.log(11112222333, res.data.orgList);
          this.removeEmptyorgList(res.data.orgList);
          this.supplierList = res.data.orgList;
        }
      );
    },
    // 递归清理空的组织，orgList 属性
    removeEmptyorgList(orgList) {
      orgList.forEach(item => {
        // 判断是否有 orgList 属性
        if (item.orgList) {
          // 如果 orgList 是空数组，则删除该属性
          if (Array.isArray(item.orgList) && item.orgList.length === 0) {
            delete item.orgList;
          } else {
            // 如果 orgList 不是空数组，递归检查 orgList 内的每一项
            this.removeEmptyorgList(item.orgList);
          }
        }
      });
    },
    //查看领取记录
    doRecord(couponId) {
      this.couponId = couponId;
      if (!couponId) return;
      var params = {
        page: this.recordFpi.page || 1,
        rows: this.recordFpi.rows || 20,
        'is:couponId|string#and': couponId,
        'regex:title|string#or': this.searchRecordValue,
        'regex:phone|string#or': this.searchRecordValue,
        'is:_id|string#or': this.searchRecordValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('/basic/couponPrinting/query.do', params, res => {
        this.recordFpi = res;
      });
    },
    doNew() {
      this.doInit();
      this.isEdit = false;
      this.openDetail = true;
    },
    doEdit(row) {
      this.isEdit = true;
      row = this.$util.deepCopy(row);
      row.type = String(row.type);
      if (row.startDate && row.endDate) row.timeRange = [row.startDate, row.endDate];
      if (row.startCouponDate && row.endCouponDate)
        row.durationTimeRange = [row.startCouponDate, row.endCouponDate];
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    //修改最大发券数
    doStock(id) {
      this.$prompt('请输入数字，正数加库存数量，负数将会减少库存数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^-?\d+$/,
        inputErrorMessage: '请输入整数',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          this.osg.ajax('basic/coupon/upsertRedis.do', { id, count: value, flag: 0 }, () => {
            this.doInit();
            this.getData();
            this.osg.toast('操作成功！');
          });
        })
        .catch(() => {});
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      if (this.osg.validate()) {
        // 校验代金券批次号数组是否填写完整
        if (this.formData.type == '5') {
          for (let i = 0; i < this.formData.ladderParts.length; i++) {
            let item = this.formData.ladderParts[i];
            if (
              (!item.ladderPrerequisite && item.ladderPrerequisite != 0) ||
              (!item.ladderAmount && item.ladderAmount != 0)
            ) {
              this.osg.toast('请填写完整代金券批次号', 'warning');
              return;
            }
          }
        }
        this.formData.exts = this.formData.exts || {};
        if (this.formData.timeRange) {
          this.formData.startDate = this.formData.timeRange[0];
          this.formData.endDate = this.formData.timeRange[1];
          this.formData.exts.startDate = this.formData.startDate.substr(
            0,
            this.formData.startDate.indexOf(' ')
          );
          this.formData.exts.endDate = this.formData.endDate.substr(
            0,
            this.formData.endDate.indexOf(' ')
          );
          delete this.formData.timeRange;
        }
        if (this.formData.durationTimeRange) {
          this.formData.startCouponDate = this.formData.durationTimeRange[0];
          this.formData.endCouponDate = this.formData.durationTimeRange[1];
          this.formData.exts.startCouponDate = this.formData.startCouponDate.substr(
            0,
            this.formData.startCouponDate.indexOf(' ')
          );
          this.formData.exts.endCouponDate = this.formData.endCouponDate.substr(
            0,
            this.formData.endCouponDate.indexOf(' ')
          );
          delete this.formData.durationTimeRange;
        }
        if (!this.isEdit) this.formData.stock = this.formData.quantity;
        if (!this.formData._id) this.formData.stock = 0;

        const { type, couponType } = this.formData;
        if (!(type == 2 || (type == 5 && couponType == 1))) {
          delete this.formData.discountLimit;
        }

        // 提取每个子数组的最后一个元素
        this.formData.scopeOrgIds = this.formData.scopeOrgIds.map(K => K[K.length - 1]);
        console.log(this.formData.scopeOrgIds);
        // 调用函数
        let newObj = this.convertValuesToString(this.formData);
        console.log(newObj);

        this.osg.ajax('basic/coupon/upsert.do', { data: JSON.stringify(newObj) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    convertValuesToString(obj) {
      // 判断是否是对象和不是 null
      if (obj === null || typeof obj !== 'object') {
        return String(obj); // 直接返回字符串
      }
      // 创建一个新的对象或数组
      const newObj = Array.isArray(obj) ? [] : {};
      Object.keys(obj).forEach(key => {
        const value = obj[key];
        // 如果值是对象，递归调用
        if (typeof value === 'object' && value !== null) {
          newObj[key] = this.convertValuesToString(value); // 递归
        } else {
          // 直接转为字符串
          newObj[key] = String(value);
        }
      });
      return newObj; // 返回新的对象
    },
    doDistribute(row) {
      this.distributeData.openDetail = true;
      this.distributeData.formData.couponId = row._id;
    },
    //查询客户
    querySearch(queryString) {
      var params = {
        page: 1,
        rows: 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#or': queryString,
        'regex:phone|string#or': queryString
      };
      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          this.$set(this.options, 'contacts', res.data);
        },
        { noload: true }
      );
    },
    //创建优惠券领取记录
    doSaveDistributeData() {
      if (this.osg.validate('distributeDataForm')) {
        this.osg.ajax(
          'basic/couponPrinting/upsert.do',
          this.distributeData.formData,
          () => {
            this.distributeData.openDetail = false;
            this.osg.toast('操作成功！');
            this.getData();
          },
          {
            noload: true
          }
        );
      }
    },
    //发放优惠券-更改客户
    distributeContactChange(contactId) {
      this.distributeData.formData.phone = this.options.contacts.find(
        item => item._id == contactId
      ).phone;
    },
    doEnable(id) {
      this.osg.ajax('basic/coupon/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/coupon/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        let that = this;
        that.osg.ajax(`basic/coupon/remove/${id}.do`, null, () => {
          that.osg.toast('删除成功');
          that.getData();
        });
      });
    },
    selectable(row) {
      if (row.scopeType == 99 && row.state == 1) {
        return true;
      } else {
        return false;
      }
    },
    onSelectionChange(rows) {
      this.selectedRows = rows;
    },
    onShareClick() {
      if (this.selectedRows.length == 0) {
        this.osg.toast('请至少勾选1条私密优惠券', 'warning');
        return;
      }
      this.queryLocationHost(baseUrl => {
        let privateCouponIds = this.selectedRows.map(item => item._id).join();
        this.privateCoupon.qrCodeKey = +new Date();
        this.privateCoupon.openDetail = true;
        this.$nextTick(() => {
          new QRCode(this.$refs.qrCodeUrl, {
            text: `${baseUrl}privateCoupon/?privateCouponIds=${privateCouponIds}`,
            width: 200,
            height: 200,
            colorDark: '#333333', //二维码颜色
            colorLight: '#ffffff', //二维码背景色
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
          });
        });
      });
    },
    //基础（前缀）路径
    queryLocationHost(callback) {
      this.osg.ajax(
        'config/queryLocationHost.do',
        {},
        res => {
          if (callback) callback(res.data);
        },
        { noload: true }
      );
    },
    downloadCode() {
      const qrcode = document.querySelector(`#qrcode_${this.privateCoupon.qrCodeKey}`);
      const canvas = qrcode.querySelector('canvas');
      const imgurl = canvas.toDataURL('image/jpeg');
      const a = document.createElement('a');
      a.href = imgurl;
      a.download = '私密优惠券二维码.png';
      a.click();
    },
    formatStockNum(row) {
      if (row.type == '5' && row.ladderParts) {
        return row.ladderParts.map(item => item.ladderStockNum).join('、');
      } else {
        return row.stockNum || '';
      }
    },
    addStock() {
      this.formData.ladderParts.push({});
    },
    removeStock(index) {
      this.formData.ladderParts.splice(index, 1);
    }
  }
};
</script>
<style lang="scss">
.coupons {
  .privateCoupon-dialog {
    .el-dialog__body {
      text-align: center;
    }
  }
  .stockNum-view {
    width: 100%;
    .el-input__inner {
      border: none;
    }
  }
}
</style>
